import Form from './form';
import AutoDropdown from './autodropdown';
import Calendar from './calendar';
import Input from './input';
import InputNumber from './inputnumber';
import InputArea from './inputarea';
import InputMultiLang from './inputmultilang';
import MultiLang from './multilang';
import Editor from './editor';
import Dropdown from './dropdown';
import OptionButton from './optionbutton';
import ColorPicker from './colorpicker';
import Password from './password';
import FormField from './FormField';
import UploadSingleFile from './uploadsinglefile';
import FormDataLoadButton from './FormDataLoadButton';
import FormDataSaveButton from './FormDataSaveButton';
import { Forms } from '..';
import Service from '../../services/common/services/formservice';

export { Form, Calendar, AutoDropdown, Input, InputNumber, InputArea, Dropdown, Editor, OptionButton, Password, UploadSingleFile, ColorPicker, InputMultiLang }
export { FormDataLoadButton, FormDataSaveButton, FormField }
export { MultiLang }

/** Propiedades básicas de los controles */
export interface IControlProps<T> {
  form?: Forms.Form | Service<any>;
  name?: string;

  // basics
  title?: string;
  placeholder?: string;
  disabled?: boolean;
  value?: T;
  icon?: string;

  // estilos
  className?: string;
  style?: React.CSSProperties;

  // valids
  required?: boolean;
  /** validacion custom. En caso de error se devuelve el texto del error. undefined para una validación exitosa */
  validate?: (value?: T) => string | undefined;
  /** ocurre cuando se valida el control */
  isValid?: (valid: boolean, error?: string) => void;

  // comportamiento
  //ref?: (e: any) => void;

  onChange?: (value?: T, error?: string) => void;
}

/**
 * Verifica los cambios entre propiedades y el estado y actualiza el objeto de estado
 * @param output objeto de estado actualizado
 * @param prop objeto con propiedades
 * @param state objeto de estado
 */
export function MapProps<T>(output: any, prop: IControlProps<T>, state?: IControlProps<T>) : any {
  if (prop?.form !== state?.form) output.form = prop.form;
  if (prop?.name !== state?.name) output.name = prop.name;
  // basics
  if (prop?.title !== state?.title) output.title = prop.title;
  if (prop?.placeholder !== state?.placeholder) output.placeholder = prop.placeholder;
  if (prop?.disabled !== state?.disabled) output.disabled = prop.disabled;
  if (prop?.value !== state?.value) output.value = prop.value;  
  if (prop?.icon !== state?.icon) output.icon = prop.icon;
  // valids
  if (prop?.required !== state?.required) output.required = prop.required;
  // estilos
  if (prop?.className !== state?.className) output.className = prop.className;
  if (prop?.style !== state?.style) output.style = prop.style;

  return output;
}